export const BUILD_VERSION = '1787883221';
